<div class="notification-saved-products">
  <div class="d-flex justify-content-end cursor-pointer" matDialogClose>
    <mat-icon>close</mat-icon>
  </div>
  <div class="content-available-information">
    <div class="d-flex justify-content-center align-items-center mb-3">
      <img
        src="assets/icons/warningPayment.svg"
        alt="warning payment"
        width="80"
      />
    </div>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <p class="font-omicron-bold color-black title-size-4">
        Tienes artículos en tu carrito guardado.
      </p>
      <p class="font-omicron-bold color-black title-size-4">
        ¿Qué te gustaría hacer?
      </p>
    </div>
    <div
      class="product-not-available-list"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
    >
      <div [ngClass]="data.length > 1 ? 'item' : ''" *ngFor="let item of data">
        <div class="row">
          <div class="col-4 col-md-2">
            <div class="d-flex flex-column">
              <p class="text-size-1 font-omicron-bold color-black">Producto</p>
              <p class="text-size-2 color-gray">
                {{ item.itemCode }}
              </p>
            </div>
          </div>
          <div class="col-8 col-sm-10">
            <div class="d-flex flex-column">
              <p class="text-size-1 font-omicron-bold color-black">
                Descripción
              </p>
              <p class="text-size-2" class="color-gray">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="not-available-product-actions">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      class="d-flex white-button font-size-button"
      (click)="redirect([routes.home])"
    >
      Ver después
    </button>
    <button
      mat-raised-button
      color="primary"
      class="blue-button font-size-button"
      (click)="redirect([routes.shoppingCar, tabs.saved])"
    >
      Administrar carrito guardado
    </button>
  </div>
</div>
